var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34795 0.83374C2.24557 0.83374 1.32624 1.67672 1.23091 2.77497L0.682839 9.08871C0.539152 10.744 1.84406 12.1671 3.50556 12.1671H11.4923C13.1538 12.1671 14.4588 10.744 14.3151 9.08871L13.767 2.77497C13.6717 1.67672 12.7523 0.83374 11.65 0.83374H3.34795ZM9.48145 3.83184C9.19705 4.68505 8.39859 5.26055 7.49923 5.26055C6.59987 5.26055 5.80141 4.68505 5.51701 3.83184L5.16989 2.79047C5.0771 2.51212 4.77625 2.36169 4.4979 2.45448C4.21956 2.54726 4.06913 2.84811 4.16191 3.12646L4.50903 4.16783C4.93806 5.45491 6.14254 6.32305 7.49923 6.32305C8.85592 6.32305 10.0604 5.45491 10.4894 4.16784L10.8366 3.12646C10.9293 2.84812 10.7789 2.54726 10.5006 2.45448C10.2222 2.36169 9.92136 2.51212 9.82858 2.79047L9.48145 3.83184Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.12a3d62e348599c27eb0a62dc93b46ff.svg";
export { ForwardRef as ReactComponent };